import React, { useLayoutEffect, useRef, useState } from 'react'
import { classNames } from '@/shared/lib/utils/classNames'
import lines from '@/shared/assets/jackpotLines.webp'
import blazingFruits from '@/shared/assets/blazingFruits.webp'
import deepSea from '@/shared/assets/deepSea.webp'
import forestPots from '@/shared/assets/forestPots.webp'
import { ReactComponent as LineArrow } from '@/shared/assets/LineArrow.svg'
import violetGlow from '@/shared/assets/violetGlow.svg'
import blueGlow from '@/shared/assets/blueGlow.svg'
import greenGlow from '@/shared/assets/greenGlow.svg'

import cls from './ProductList.module.scss'

export const ProductList = () => {
    const [current, setCurrent] = useState(0)
    const [translateX, setTranslateX] = useState(0)
    const sliderRef = useRef()
    const imageList = [blazingFruits, deepSea, forestPots]
    const productList = [
        {
            glow: violetGlow,
            title: 'Blazing fruits',
            description:
                'A classic fruit slot with modern features! Dynamic gameplay, vibrant design, and generous bonuses make Blazing Fruits a true player favorite.',
        },
        {
            glow: blueGlow,
            title: 'Deep Sea \nTreasure',
            description:
                'Dive into an underwater adventure with Deep Sea Treasure! Explore the depths, uncover hidden riches, and spin your way to big wins with exciting bonus features.',
        },
        {
            glow: greenGlow,
            title: 'Forest Pots \nof Riches',
            description:
                'Step into an enchanted forest where luck awaits! Forest Pots of Riches brings magical gameplay, lucky charms, and golden treasures that keep players coming back for more.',
        },
    ]

    const actionHandler = (action) => {
        if (action === 'next') {
            if (current >= productList.length - 1) {
                setCurrent(0)
            } else {
                setCurrent(current + 1)
            }
        } else if (action === 'prev') {
            if (current <= 0) {
                setCurrent(imageList.length - 1)
            } else {
                setCurrent(current - 1)
            }
        }
    }

    useLayoutEffect(() => {
        setTranslateX(sliderRef.current.children[0].clientWidth * current)
    }, [current])
    return (
        <section className={cls.ProductList}>
            <img
                src={lines}
                alt=""
                className={cls.JackpotLines}
            />
            <div className={cls.glowContainer}>
                {productList.map((item, index) => (
                    <img
                        src={item.glow}
                        className={classNames(cls.glow, [], {
                            [cls.active]: index === current,
                        })}
                        alt=""
                    />
                ))}
            </div>
            <article className={cls.imagesRoot}>
                <div
                    ref={sliderRef}
                    className={cls.imagesContainer}
                    style={{ transform: `translate3D(${-translateX}px, 0px, 0px)` }}
                >
                    {imageList.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={productList[index]}
                            className={cls.image}
                        />
                    ))}
                </div>
            </article>
            <article className={cls.details}>
                <p className={cls.title}>our games</p>
                <div className={cls.textDetails}>
                    {productList.map((item, index) => (
                        <div
                            className={classNames(cls.item, [], {
                                [cls.active]: index === current,
                            })}
                        >
                            <h1>{item.title}</h1>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
                <div className={cls.controls}>
                    <LineArrow
                        onClick={() => actionHandler('prev')}
                        className={classNames(cls.arrow, [cls.prev])}
                    />
                    <p>
                        {current + 1}
                        <span>/3</span>
                    </p>
                    <LineArrow
                        onClick={() => actionHandler('next')}
                        className={classNames(cls.arrow, [cls.next])}
                    />
                </div>
            </article>
        </section>
    )
}
